import { useState } from "react"
import { useNavigate } from "react-router-dom"

import { CadastrarTicket } from "./CadastrarTicket"
import { TicketSupportForm } from "../../types/atendimentos/pre-atendimento/types"
import { useShowNotification } from "../../hooks/useShowNotificationContext"
import { useAnexarArquivoAtendimento, useCadastrarAtendimento } from "../../services/atendimentos/useAtendimentos"
import { LoadingOverlay } from "../../components/Loading"
import { useUserStore } from "../../store/user"
import { useFetchContatos } from "../../services/clientes/useClientes"
import { useAuth } from "../../contexts/AuthContext"
import { NotFound } from "../../components/NotFound"
import { readAsBase64 } from "../../utils/utils"

export const CadastrarTicketContainer = () => {
    const { oidCliente } = useAuth()
    const user = useUserStore((state) => state.user)

    const defaultFilter: TicketSupportForm = {
        oidCliente: oidCliente ?? 0,
        oidresponsavel: user?.oidResponsavel ?? 0,
        criadoPorUsuarioMaster: user?.isMaster ? 1 : 0,
        oidOpcao: 2330626,
        oidSistema: 2330626,
        descricao: '',
        versao: '',
        oidContato: 0,
    }

    const { data, isFetching, isError, error, refetch } = useFetchContatos(
        oidCliente ?? 0,
        {
            enabled: !!oidCliente,
            staleTime: Infinity,
        }
    );

    const [form, setForm] = useState<TicketSupportForm>(defaultFilter)
    const [files, setFiles] = useState<File[]>([]);

    const { showSucessNotification, showErrorNotification } = useShowNotification()
    const navigate = useNavigate()
    const cadastrarAtendimento = useCadastrarAtendimento()
    const anexarArquivoAtendimento = useAnexarArquivoAtendimento()


    const onCreate = (formData: TicketSupportForm) => {
        setForm(formData)
        cadastrarAtendimento.mutate({
            ...formData,
            descricao: formData.descricao?.replaceAll("\n", "<br/>"),
        }, {
            onSuccess: async (atendimento) => {
                showSucessNotification("Pré-atendimento criado com sucesso!");
                if (files.length > 0) {
                    await onSendFiles(atendimento.oidTopico)
                }

                navigate('/tickets')
            },
            onError: (e) => {
                showErrorNotification(e, 'Falha ao criar o pré-atendimento: verifique os dados e tente novamente.');
            },
        })
    }

    const onSendFiles = async (oidTopico: number) => {
        let successes = 0
        let failures = 0

        for (const file of files) {
            const extensionFile = file.name.split(".").pop() || ""
            const baseName = file.name.replace(/\.[^/.]+$/, "")

            try {
                const base64 = await readAsBase64(file)

                await anexarArquivoAtendimento.mutate({
                    numeroTopicoPreAtendimento: oidTopico,
                    arquivo: base64,
                    nomeArquivo: baseName,
                    referencia: baseName,
                    tipoArquivo: extensionFile,
                })

                successes++
            } catch (e) {
                console.error(e);
                failures++
                showErrorNotification(null, `Falha ao anexar "${file.name}".`)
            }
        }

        if (successes > 0) {
            showSucessNotification(successes === 1 ? "Arquivo anexado com sucesso!" : `${successes} arquivos anexados com sucesso!`)
        }

        if (failures === 0) {
            setFiles([]);
        }
    }



    const onCleanFields = () => {
        setForm(defaultFilter)
        setFiles([]);
    }

    const onRemoveFile = (index: number) => {
        setFiles((prev) => prev.filter((_, i) => i !== index));
    };


    return (
        <>

            {isError && (
                <NotFound
                    error={error}
                    defaultMessage={'Erro ao carregar a lista de contatos.'}
                    retry={refetch}
                />
            )}
            {(anexarArquivoAtendimento.isPending || cadastrarAtendimento.isPending || isFetching) && <LoadingOverlay />}

            {data && user && <CadastrarTicket
                form={form}
                user={user}
                contacts={data}
                files={files}
                onCreate={onCreate}
                onCleanFields={onCleanFields}
                onFilesChange={setFiles}
                onClearAllFiles={() => setFiles([])}
                onRemoveFile={onRemoveFile}
            />
            }
        </>
    )
}